import { createApiClient } from '@/shared/api/createApiClient';
import { addSpoofInterceptor } from '@/shared/spoof/addSpoofInterceptor';

export const claimflowApiClient = createApiClient(
  'claimflow_auth_token',
  'claimflow_active_tenant_id',
);

addSpoofInterceptor(claimflowApiClient, 'claimflow', 'claimflow_session_id');
